import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { Magnetic } from "@/components/Magnetic";

const links = [
  { label: "Our Facility", href: "#kitchens" },
  { label: "The Difference", href: "#difference" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Corridor Walk", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-gold/15 bg-[#141416]/70 backdrop-blur-xl" data-testid="navbar">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 md:px-8">
        <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center" data-testid="nav-logo">
          <img src="/assets/brand/logo.webp" alt="Royal Express Cloud Kitchen logo" className="h-14 w-auto mix-blend-screen" />
        </a>
        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[11px] uppercase tracking-[0.24em] text-white/70 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Magnetic strength={0.25} className="hidden sm:inline-flex">
            <a
              href="#contact"
              onClick={(e) => go(e, "#contact")}
              data-testid="nav-partner-cta"
              className="inline-flex rounded-full bg-gold px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.18em] text-black transition-colors duration-300 hover:bg-gold-light"
            >
              Partner With Us
            </a>
          </Magnetic>
          <button className="text-white lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label="Toggle menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="border-t border-gold/15 bg-black/95 px-6 py-6 backdrop-blur-xl lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm uppercase tracking-[0.22em] text-white/80 transition-colors duration-300 hover:text-gold"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => go(e, "#contact")}
              data-testid="nav-mobile-partner-cta"
              className="mt-2 inline-flex w-fit rounded-full bg-gold px-6 py-3 text-xs font-bold uppercase tracking-[0.18em] text-black"
            >
              Partner With Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
